var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "pagination-wrapper-flex",
    },
    [
      _c(
        "p",
        {
          staticClass: "audible",
          attrs: {
            id: _vm.pagination_id,
          },
        },
        [_vm._v("\n        " + _vm._s(_vm.$gettext("Blättern")) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "ul",
        {
          staticClass: "pagination",
          attrs: {
            role: "navigation",
            "aria-labelledby": _vm.pagination_id,
          },
        },
        [
          _vm.currentOffset > 0
            ? _c(
                "li",
                {
                  staticClass: "prev",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "pagination--link",
                      attrs: {
                        rel: "prev",
                        title: _vm.$gettext("Zurück"),
                      },
                      on: {
                        click: function click($event) {
                          $event.preventDefault()
                          return _vm.goBack.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "audible",
                        },
                        [_vm._v(_vm._s(_vm.$gettext("Eine Seite")))]
                      ),
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$gettext("zurück")) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.offsets, function (offset) {
            return [
              offset === _vm.total_offsets - 1 &&
              _vm.currentOffset < _vm.total_offsets - 1 - (_vm.range + 1)
                ? _c(
                    "li",
                    {
                      key: "end-dots-" + offset,
                      staticClass: "divider",
                    },
                    [_vm._v("\n                …\n            ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "li",
                {
                  key: "offset-" + offset,
                  class: {
                    current: offset === _vm.currentOffset,
                    "no-divider": offset === 0,
                  },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "pagination--link",
                      on: {
                        click: function click($event) {
                          $event.preventDefault()
                          return _vm.goTo(offset)
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "audible",
                        },
                        [_vm._v(_vm._s(_vm.$gettext("Seite")))]
                      ),
                      _vm._v(
                        "\n                    " +
                          _vm._s(offset + 1) +
                          "\n                "
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              offset === 0 && _vm.currentOffset > _vm.range + 1
                ? _c(
                    "li",
                    {
                      key: "start-dots" + offset,
                      staticClass: "divider",
                    },
                    [_vm._v("\n                …\n            ")]
                  )
                : _vm._e(),
            ]
          }),
          _vm._v(" "),
          _vm.currentOffset < _vm.total_offsets - 1
            ? _c(
                "li",
                {
                  staticClass: "next no-divider",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "pagination--link",
                      attrs: {
                        rel: "next",
                        title: _vm.$gettext("Weiter"),
                      },
                      on: {
                        click: function click($event) {
                          $event.preventDefault()
                          return _vm.goNext.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "audible",
                        },
                        [_vm._v(_vm._s(_vm.$gettext("Eine Seite")))]
                      ),
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$gettext("weiter")) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }